import * as React from 'react';
import '../../../../../../context/actions.js';
import '../../../../../../context/reducer.js';
import { useProductData } from '../../../../../../context/product-context-hooks.js';
import '../../../../../../context/ProductContext.js';
import '../../../../../../context/CmsContext.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '../../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '../../../../../../types/product.js';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { useCLEcommContext } from '../../../context/CLEcommContext.js';
import '../../../operations/queries/get-contact-lens-by-prescription.js';
import { useFetchCLByPrescription } from '../../../hooks/use-fetch-cl-by-prescription.js';

const useFetchCLForActiveVariant = ({ eyeSide  })=>{
    const { activeVariant  } = useProductData();
    const { state , selectors  } = useCLEcommContext();
    const { prescription  } = state.configurations[eyeSide];
    const rxColumnValidations = selectors.isRxColumnValid(state);
    const isValid = rxColumnValidations[eyeSide];
    const { isEnabled  } = state.configurator[eyeSide];
    const fetchCLByPrescription = useFetchCLByPrescription({
        eyeSide
    });
    React.useEffect(()=>{
        if (!isValid || !isEnabled) {
            return;
        }
        fetchCLByPrescription(prescription);
    }, [
        fetchCLByPrescription,
        activeVariant,
        prescription,
        isEnabled,
        isValid
    ]);
};

export { useFetchCLForActiveVariant };
//# sourceMappingURL=use-fetch-cl-for-active-variant.js.map
